import React from "react";
import { Dialog, DialogContent, Button } from "@mui/material";
import "../css/SpecialOnboardingValidationDialog.css";

const SpecialOnboardingValidationDialog = ({ open, onClose }) => {
  return (
    <Dialog
      open={open ?? false}
      onClose={onClose}
      PaperProps={{
        className: "special-onboarding-validation-dialog-container",
      }}
    >
      <DialogContent>
        <div className="special-onboarding-validation-dialog-content">
          <div className="special-onboarding-validation-dialog-title-container">
            <div className="special-onboarding-validation-dialog-title">
              Please note: Special Onboarding request is not planned 36 hours in
              advance.
              <br />
              <br /> Special onboarding fee will be added to other fees in
              Payment Summary.
            </div>
          </div>
          <Button variant="contained" onClick={onClose}>
            Yes
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SpecialOnboardingValidationDialog;
